import { useState } from "react";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { IndicatorsDay } from "../components/IndicatorsDay";
import { IndicatorsWeek } from "../components/IndicatorsWeek";
import { IndicatorsMonth } from "../components/IndicatorsMonth";
import { IndicatorsYear } from "../components/IndicatorsYear";
import { IndicatorsLastTwelve } from "../components/IndicatorsLastTwelve";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";
import { PageTitle } from "../components/shared/PageTitle";
import { BtnPill } from "../components/Buttons/BtnPill";
import "../theme/Indicadores.css";
import { useDynamicAuth } from "../context/AuthProviderContext";

const TIME_PERIODS = [
  { value: "day", label: "Día" },
  { value: "week", label: "Semana" },
  { value: "month", label: "Mes" },
  { value: "year", label: "Año" },
  { value: "lastTwelve", label: "Últimas 12" },
];


export const IndicadoresPage = () => {
  const [changeDate, setChangeDate] = useState("day");
  const authProvider = useDynamicAuth();

  const renderIndicatorContent = () => {
    switch (changeDate) {
      case "day":
        return <IndicatorsDay />;
      case "week":
        return <IndicatorsWeek />;
      case "month":
        return <IndicatorsMonth />;
      case "year":
        return <IndicatorsYear />;
      case "lastTwelve":
        return <IndicatorsLastTwelve />;
      default:
        return <IndicatorsDay />;
    }
  };

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <BtnGoBack caption="Volver a inicio" />
                </div>
              </div>

              <PageTitle title="Indicadores" />

              <div className="title-name-row">
                {TIME_PERIODS.map((period) => (
                  <BtnPill
                    key={period.value}
                    label={period.label}
                    value={period.value}
                    isActive={changeDate === period.value}
                    onClick={setChangeDate}
                  />
                ))}
              </div>

              <div className="page-container">{renderIndicatorContent()}</div>
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
